var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyTerm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 50 50",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#ffffff;}.cls-3{fill:#ff8e5a;}.cls-4{fill:#ffba50;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.693,41.394,35.38,32.607l2.52-2.52.036.036a1.671,1.671,0,0,0,2.36,0l.656-.655a1.674,1.674,0,0,0,0-2.36L33.5,19.654a1.718,1.718,0,0,0-.277-.222V7a2.5,2.5,0,0,0-2.5-2.5H7A2.5,2.5,0,0,0,4.5,7V43A2.5,2.5,0,0,0,7,45.5H30.72a2.5,2.5,0,0,0,2.5-2.5V36.03l8.173,8.663a2.335,2.335,0,0,0,1.657.807h.029a2.338,2.338,0,0,0,1.614-4.106Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.72,44.5H28.64a2.574,2.574,0,0,0-2.546-2.263h-.027A2,2,0,0,0,24.075,40.3H13.644a2,2,0,0,0-1.991,1.938h-.027A2.573,2.573,0,0,0,9.08,44.5H7A1.5,1.5,0,0,1,5.5,43V7A1.5,1.5,0,0,1,7,5.5H30.72A1.5,1.5,0,0,1,32.22,7V19.175a1.656,1.656,0,0,0-1.082.479l-.655.656a1.667,1.667,0,0,0,0,2.359l.036.037L23,30.229l-.037-.036a1.669,1.669,0,0,0-2.359,0l-.655.656a1.667,1.667,0,0,0,0,2.359L27.4,40.662a1.668,1.668,0,0,0,2.36,0l.655-.655a1.672,1.672,0,0,0,0-2.36l-.036-.036,1.844-1.844V43A1.5,1.5,0,0,1,30.72,44.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.863,12.761H26.857a.5.5,0,0,0,0-1H10.863a.5.5,0,0,0,0,1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.863,18.307H26.857a.5.5,0,0,0,0-1H10.863a.5.5,0,0,0,0,1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.863,23.854H26.857a.5.5,0,0,0,0-1H10.863a.5.5,0,0,0,0,1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.863,29.4H20.07a.5.5,0,0,0,0-1H10.863a.5.5,0,0,0,0,1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.77,33.946H10.863a.5.5,0,0,0,0,1H18.77a.5.5,0,0,0,0-1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    height: 8.439,
    transform: "translate(-12.407 30.363) rotate(-45)",
    width: 10.641,
    x: 25.127,
    y: 25.939
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.705,38.354a.669.669,0,0,1,0,.946l-.655.655a.684.684,0,0,1-.946,0L20.651,32.5a.668.668,0,0,1,0-.945l.655-.656a.67.67,0,0,1,.945,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.245,27.815a.671.671,0,0,1,0,.946l-.656.655a.67.67,0,0,1-.946,0L31.19,21.962a.668.668,0,0,1,0-.945l.655-.656a.67.67,0,0,1,.945,0Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.094,43.237A1.582,1.582,0,0,1,27.64,44.5H10.08a1.581,1.581,0,0,1,1.546-1.263Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.659,42.237a.991.991,0,0,1,.985-.938H24.075a.992.992,0,0,1,.986.938Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.035,44.035a1.321,1.321,0,0,1-.971.465,1.347,1.347,0,0,1-.943-.493l-8.806-9.334,1.358-1.358,9.334,8.806a1.351,1.351,0,0,1,.493.943A1.406,1.406,0,0,1,44.035,44.035Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyTerm);
export default __webpack_public_path__ + "static/media/policy-term.ffbcad1c77906b088b6e9c5a3204f28e.svg";
export { ForwardRef as ReactComponent };